import { ThemeProvider } from "@emotion/react";
import { EditComponentProps } from "@material-table/core";
import { Box, Checkbox, CheckboxProps, createTheme } from "@mui/material";
import { SInputProps } from "components/parts";
import { STheme } from "components/styles";

type Props = Partial<Omit<CheckboxProps, "value" | "type">> &
  Pick<SInputProps, "align"> & {
    editProps: EditComponentProps<any>;
    value: string | number;
    on: string | number;
    off: string | number;
  };

export const SCodeCheckCell = ({
  ref,
  value,
  defaultValue,
  align,
  editProps,
  on,
  off,
  ...props
}: Props): JSX.Element => {
  const theme = createTheme(
    {
      components: {
        MuiCheckbox: {
          styleOverrides: {
            root: {
              padding: 0,
            },
          },
        },
      },
    },
    { STheme }
  );

  return (
    <ThemeProvider theme={theme}>
      <Box display="flex" justifyContent={align}>
        <Checkbox
          {...props}
          ref={ref}
          value={value}
          onBlur={(event) => {
            props.onBlur?.call(this, event);
          }}
          onChange={(event, checked) => {
            editProps.onChange(checked ? on : off);
            props.onChange?.call(this, event, checked);
          }}
          checked={value === on}
          inputProps={{ ...props.inputProps, tabIndex: 0 }}
        />
      </Box>
    </ThemeProvider>
  );
};
